export default __webpack_public_path__ + "static/Group 601-fc973782c2515503b37a92b83a8c827e.png";